module.exports = __webpack_public_path__ + "img/epr-price@2x.d3bbcbca.jpg";